import { get, post } from '@/lib/api';

const requestAppFixer = ({ path, data, query, callback }) => {
  const method = data === undefined ? get : post;
  const encodedQuery = query && Object.fromEntries(Object.entries(query).map(([key, value]) => [key, value == null ? value : encodeURIComponent(String(value))]));
  return method(`v1/app-fixer/${path}`, { action: 'APP_FIXER_REQUEST', data, query: encodedQuery, callback });
};

export default requestAppFixer;
